import { render, staticRenderFns } from "./TazminatAlacakKalemiForm.vue?vue&type=template&id=1b27804a"
import script from "./TazminatAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./TazminatAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports